import angular from 'angular';
import uiRouter from 'angular-ui-router';
import OperationTypeComponent from './operation-type.component';

let OperationTypeModule = angular
  .module('OperationType', [uiRouter])

  .config($stateProvider => {
    'ngInject';
    $stateProvider
      .state('newOperationType', {
        url: '/operation-types/new',
        component: 'operationType',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {}
      })
      .state('editOperationType', {
        url: '/operation-types/:id',
        component: 'operationType',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {
          operationType: (OperationTypesService, $stateParams) => {
            return OperationTypesService.findById($stateParams.id, {
              include: ['statesTemplates']
            });
          }
        }
      });
  })
  .component('operationType', OperationTypeComponent).name;

export default OperationTypeModule;
